import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PinSelectedIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PinSelectedIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 56 56">
      <g>
        <g>
          <path d="M54.07,20.06L35.94,1.92l-3.36,3.36l-1.07,7.87l-7.83,7.83L11.3,22.02L6.83,26.5l11.33,11.33L29.5,49.17 l4.48-4.48l-0.09-13.51l7.83-7.83l9.01,0.06L54.07,20.06z" />
        </g>
        <g>
          <path d="M2.5,55.5c-0.51,0-1.02-0.2-1.41-0.59c-0.78-0.78-0.78-2.05,0-2.84l14.24-14.25L5.41,27.9v-2.84l4.48-4.48 L11.14,20l11.65-0.98l6.83-6.83L30.61,5l0.57-1.14l3.36-3.36h2.83L55.5,18.63v2.84l-3.36,3.36l-1.43,0.59l-8.17-0.05l-6.65,6.64 l0.08,12.67l-0.59,1.43l-4.48,4.48h-2.83l-9.92-9.92L3.92,54.91C3.53,55.3,3.02,55.5,2.5,55.5z M19.58,36.42l9.92,9.92l2.46-2.46 L31.88,31.2l0.59-1.43l7.83-7.82l1.43-0.59l8.17,0.05l1.34-1.34L35.94,4.76l-1.46,1.46l-0.98,7.2l-0.57,1.14L25.1,22.4l-1.25,0.58 L12.2,23.96L9.66,26.5L19.58,36.42z" />
        </g>
      </g>
    </Icon>
  )
}
export default PinSelectedIcon
